import api from "../../http";
import { toApiError } from "../utils";

export type ImportFertilizerParams = {
    file: File;
};

export type FertilizerImportResponse = {
    created: number;
    totalRows: number;
    errors: {
        row: number;
        message: string;
    }[];
    fertilizers: unknown;
};

export async function importFertilizerFile({
    file
}: ImportFertilizerParams): Promise<FertilizerImportResponse> {
    const formData = new FormData();

    formData.append("file", file);

    try {
        const response = await api.post("/products/fertilizer/import", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });

        return response.data;
    } catch (error) {
        throw toApiError(error, "Erro ao importar fertilizantes");
    }
}
